<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage organizations</h1>
                    <a v-sanitizedHref="`/#/admin/organizations/users/manage/organization`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-exchange" aria-hidden="true"></i>
                        <span>Change user's organization</span>
                    </a>
                    <a v-sanitizedHref="`/#/admin/organizations/users/manage/roles`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-user-secret" aria-hidden="true"></i>
                        <span>Assign Global Admin</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <a :href="`/#/admin/organizations/create`" role="button" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        <span>New organization</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container" style="margin-bottom: 40px;">
            <div class="row">
                <div v-for="o in organizations" :key="o.OrganizationUnitId" class="col-md-4 col-sm-6" style="margin-bottom: 20px;">
                    <div class="card bg-light">
                        <div class="card-header">
                            <a :href="`/#/admin/organizations/dashboard/${o.OrganizationUnitId}`">{{o.Name}}</a>
                        </div>
                        <div class="card-body">
                            <p class="card-text">{{o.Description || 'No description'}}</p>
                            <p>
                                Admins count: {{o.AdminsCount}}<br/>
                                <a :href="`/#/admin/organizations/users/createorganizationadmin/${o.OrganizationUnitId}`" class="card-link">Set up admin</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/OrganizationUnits/Domain/queries-vue-component";

    @Component
    export default class ManageOrganizationsPage extends mixins(PageBase, VuePageQueries) {
        mounted() {
            this.setTitle('Manage organizations');
            this.runOrganizationUnitsQueryV1();
        }

        get organizationUnitsListModel() { return this.model?.OrganizationUnitsList; }
        get organizations() { return this.organizationUnitsListModel?.OrganizationUnits || []; }
    }
</script>

<style scoped>
</style>